export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://usfanslink.site').replace(/\/+$/, '');

export const SITE_NAME = 'USFansLink';

export const SITE_DESCRIPTION =
  'USFans Spreadsheet is an independent resource hub for product links, QC guides, shipping costs, warehouse info and safe buying tips.';

export function buildWebsiteSchema(lang: string): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    inLanguage: lang,
    description: SITE_DESCRIPTION,
  };
}

export function buildOrganizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
  };
}

interface ArticleSchemaOptions {
  lang: string;
  path: string;
  headline: string;
  description: string;
  image?: string;
  datePublished?: string;
}

export function buildArticleSchema(options: ArticleSchemaOptions): Record<string, unknown> {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: options.headline,
    description: options.description,
    inLanguage: options.lang,
    author: {
      '@type': 'Organization',
      name: 'USFansLink Editorial Team',
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
    },
    mainEntityOfPage: `${SITE_URL}/${options.lang}${options.path}`,
  };

  if (options.image) {
    schema.image = options.image;
  }
  if (options.datePublished) {
    schema.datePublished = options.datePublished;
    schema.dateModified = options.datePublished;
  }

  return schema;
}

export function buildFaqSchema(faqs: { q: string; a: string }[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}